export default {"src":"/_next/static/media/diagram.d815b123.svg","height":1097,"width":1715,"blurWidth":0,"blurHeight":0};